import { TCase } from '@core/modules/mdr/mdr'
import { GetCasesResponseData_Output } from '@atbay/salesforce-mdr-gateway-node-sdk/lib/types/models/GetCasesResponseData_Output'
import { removeSpaces } from '@ui/utils/utils'

const NETWORK_CONTAINMENT_ACTIONS = [
    'Account Locking',
    'Email Removal',
    'Inbound Traffic Filtering',
    'Network Traffic Filtering',
    'Outbound Traffic Filtering',
    'Executable Denylisting',
]

export const splitRemediationActions = (
    remediationAction: string | null | undefined
): string[] => {
    if (!remediationAction || typeof remediationAction !== 'string') {
        return []
    }

    return remediationAction.split(';').map((action) => action.trim())
}

export const isNetworkContainmentAction = (
    remediationAction: string
): boolean => NETWORK_CONTAINMENT_ACTIONS.includes(remediationAction)

export const transformGetCasesResponseData = (
    data: GetCasesResponseData_Output
): TCase => {
    return <TCase>{
        alerts: data.alerts.map((alert) => ({
            caseNumber: alert.case_number,
            closeReason: alert.close_reason ?? '',
            createdAt: alert.created_at,
            createdBy: alert.created_by,
            externalDetectionId: alert.external_detection_id ?? '',
            detectionUrl: alert.detection_url ?? '',
            description: alert.description,
            disposition: alert.disposition ?? '',
            incidentId: alert.incident_id ?? '',
            investigationNotes: alert.investigation_notes ?? '',
            isDeleted: String(alert.is_deleted),
            lastModifiedAt: alert.last_modified_at,
            lastModifiedBy: alert.last_modified_by,
            remediationAction: splitRemediationActions(
                alert.remediation_action
            ),
            remediationNotes: alert.remediation_notes ?? '',
            salesforceCaseId: alert.salesforce_case_id,
            severity: alert.severity,
            status: removeSpaces(alert.status.toLowerCase()),
            title: alert.title,
            caseType: alert.case_type,
            securityPlatform: alert.security_platform ?? '',
            childAlerts: [],
            affectedHost: alert.hostname ?? '',
            affectedUsers: '', //alert.affected_users ?? "",
            caseSource: alert.detection_source_product ?? '',
            networkContainment: isNetworkContainmentAction(
                alert.remediation_action || ''
            )
                ? 'Active'
                : 'Inactive',
        })),

        incidents: data.incidents.map((incident) => ({
            caseNumber: incident.case_number,
            closeReason: incident.close_reason ?? '',
            createdAt: incident.created_at,
            createdBy: incident.created_by,
            description: incident.description,
            disposition: incident.disposition ?? '',
            investigationNotes: incident.investigation_notes ?? '',
            isDeleted: incident.is_deleted,
            lastModifiedAt: incident.last_modified_at,
            lastModifiedBy: incident.last_modified_by,
            remediationAction: splitRemediationActions(
                incident.remediation_action
            ),
            remediationNotes: incident.remediation_notes ?? '',
            salesforceCaseId: incident.salesforce_case_id,
            severity: incident.severity,
            status: removeSpaces(incident.status.toLowerCase()),
            title: incident.title,
            caseType: incident.case_type,
            affectedHost: incident.hostname ?? '',
            affectedUsers: '', //alert.affected_users ?? "",
            networkContainment: isNetworkContainmentAction(
                incident.remediation_action || ''
            )
                ? 'Active'
                : 'Inactive',
            childAlerts: [],
        })),

        serviceRequests: data.service_requests.map((sr) => ({
            caseNumber: sr.case_number,
            closeReason: sr.close_reason ?? '',
            createdAt: sr.created_at,
            createdBy: sr.created_by,
            description: sr.description,
            isDeleted: sr.is_deleted,
            lastModifiedAt: sr.last_modified_at,
            lastModifiedBy: sr.last_modified_by,
            salesforceCaseId: sr.salesforce_case_id,
            status: removeSpaces(sr.status.toLowerCase()),
            title: sr.title,
            caseType: sr.case_type,
        })),
    }
}
